import type { Project } from "../../types/project";

export const skillNavigator: Project = {
  id: "skill-navigator",
  title: "Skill Navigator",
  description:
    "SkillNavigator is a web app that connects users to job opportunities based on their skills. Users can explore companies using their preferred technologies and apply via career pages, while recruiters can post and manage jobs through an easy-to-use interface.",
  techStack: ["React", "Node.js", "Express.js", "MongoDB"],
  githubUrl: "https://github.com/thvvamshi/skillNavigator",
  liveUrl: "https://skill-navigator.vercel.app/",
  image:
    "https://res.cloudinary.com/dqxd8pvye/image/upload/v1749399608/skillnav_toqfdd.png",
  featured: false,
  category: "Full Stack",
};
